import React from "react";
import {Button, withStyles} from '@material-ui/core';

const MyButton = withStyles({
    root: {
        boxShadow: ({boxshadow}) => boxshadow ? boxshadow : "2px 2px 5px 0 rgba(0, 0, 0, 0.5)",
        background: 'transparent',
        "&:hover": {
            backgroundColor: 'transparent',
        },
        width: ({width}) => width ? width : '100%',
        height: ({height}) => height ? height : '100%'

    },
    label: {
        textTransform: 'capitalize',
        fontSize: ({fontSize}) => fontSize ? fontSize : 14,
        fontWeight: 'bold'
    },

})(Button)

export default function IconTitleButtonRound(props) {
    let textcolor = "var(--white)"
    if (props.textcolor) {
        textcolor = props.textcolor
    }
    let backgroundcolor = "var(--gray_4)"
    if (props.backgroundcolor) {
        backgroundcolor = props.backgroundcolor
    }
    let borderradius = "2em"
    if (props.borderradius) {
        borderradius = props.borderradius
    }
    let fontSize = "smallTextBold"
    if (props.fontSize) {
        fontSize = props.fontSize
    }
    let direction = "rtl"
    if (props.direction) {
        direction = props.direction
    }
    return (
        <MyButton style={{
            backgroundColor: backgroundcolor,
            borderRadius: borderradius,
            direction: direction,
        }} {...props}>
            <table>
                <tbody>
                <tr>
                    {props.icon && props.iconLeft &&
                        <td style={{paddingTop: "0.5em"}}>
                            {props.icon}
                        </td>
                    }
                    <td>
                        <label
                            className={fontSize}
                            style={{color: textcolor, whiteSpace: "nowrap"}}>
                            {props.title}
                        </label>
                    </td>
                    {props.icon && !props.iconLeft &&
                        <td style={{paddingTop: "0.5em"}}>
                            {props.icon}
                        </td>
                    }
                </tr>
                </tbody>
            </table>
        </MyButton>

    )
}